import React, { useContext, useEffect, useState, useRef } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { useNavigate, useLocation } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { NumericFormat } from 'react-number-format';
import { isValidEmail } from '../../services/UtilService';
import { nlPost } from '../../apis/notLoginApi';

const AdminInfo = () => {
  useEffect(() => {
    document.title = '기업사용자관리';
  }, []);

  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);

  const validateService = new ValidateService(modalService);
  const navigate = useNavigate();
  const location = useLocation();
  const [dplChkBool, setDplChkBool] = useState(true);
  const [userEmlChg, setUserEmlChg] = useState(false);

  const [formData, setFormData] = useState({
    entSn: '',
    entId: '',
    entNm: '',
    entRprsv: '',
    entAddr: '',
    entDaddr: '',
    entZip: '',
    entTelno: '',
    entFxno: '',
    picNm: '',
    picTelno: '',
    picDept: '',
    picMblTelno: '',
    userType: '',
  });

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entId: store.userId || '',
        userType: store.userType || '',
      }));
    }
  }, [store]);

  useEffect(() => {
    if (
      formData.entId !== undefined &&
      formData.entId !== null &&
      formData.entId !== '' &&
      formData.userType !== undefined &&
      formData.userType !== null &&
      formData.userType !== ''
    ) {
      getEntUserInfo();
    }
  }, [formData.entId]);

  const getEntUserInfo = async () => {
    const url = '/member/getUserInfo.do';
    const param = {
      userId: formData.entId.replace(/\s+/g, ''),
      userType: formData.userType,
    };
    await dbPost(url, param)
      .then(response => {
        setFormData(prevFormData => ({
          ...prevFormData,
          entSn: response.entSn || '',
          entNm: response.entNm || '',
          entRprsv: response.entRprsv || '',
          entAddr: response.entAddr || '',
          entDaddr: response.entDaddr || '',
          entZip: response.entZip || '',
          entTelno: response.entTelno || '',
          entFxno: response.entFxno || '',
          picNm: response.picNm || '',
          picDept: response.picDept || '',
          picTelno: response.picTelno || '',
          picMblTelno: response.picMblTelno || '',
          picEml: response.picEml || '',
          picOrgnlEml: response.picEml || '',
        }));
      })
      .catch(error => {});
  };

  const beforeUpdate = async () => {
    const validationRules = {
      entNm: { presence: true },
      entRprsv: { presence: true },
      entAddr: { presence: true },
      entDaddr: { presence: true },
      entZip: { presence: true },
      entTelno: { presence: true },
      entFxno: { presence: true },
      picNm: { presence: true },
      picDept: { presence: true },
      picTelno: { presence: true },
      picMblTelno: { presence: true },
      picEml: { presence: true, email: true },
    };

    const altKey = {
      entNm: '회사명',
      entRprsv: '대표자',
      entAddr: '주소',
      entDaddr: '상세주소',
      entZip: '우편번호',
      entTelno: '전화번호',
      entFxno: '팩스번호',
      picNm: '담당자명',
      picDept: '담당부서',
      picTelno: '전화번호',
      picMblTelno: '휴대전화',
      picEml: '담당자 이메일 주소',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }
    if (dplChkBool == true && userEmlChg == false) {
      updateEntUserInfo();
    } else {
      modalService.errorAlert('이메일 중복확인을 해주세요.', () => {});
      return;
    }
  };

  const updateEntUserInfo = () => {
    const url = '/member/updateUserInfo.do';
    const param = {
      entNm: formData.entNm,
      entRprsv: formData.entRprsv,
      entAddr: formData.entAddr,
      entDaddr: formData.entDaddr,
      entZip: formData.entZip,
      entTelno: formData.entTelno,
      entFxno: formData.entFxno,
      picNm: formData.picNm,
      picDept: formData.picDept,
      picTelno: formData.picTelno,
      picMblTelno: formData.picMblTelno,
      picEml: formData.picEml,
      entSn: formData.entSn,
      userType: formData.userType,
    };

    if (param.userId != '' && param.userType != '') {
      dbPost(url, param)
        .then(response => {
          if (response instanceof Error) {
            this.modalService.errorAlert(
              '데이터 처리중 에러가 발생하였습니다',
              () => {}
            );
          } else {
            if (response == true) {
            } else if (response == false) {
            }
          }
          modalService.successAlert('사용자 정보를 수정하였습니다.', () => {});
        })
        .catch(error => {});
    }
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
    if (id === 'picEml') {
      setUserEmlChg(true);
      setDplChkBool(false);
    }
  };

  // 카카오 주소 검색
  const handleAddressSearch = () => {
    new daum.Postcode({
      oncomplete: function (data) {
        setFormData(prevFormData => ({
          ...prevFormData,
          entAddr: data.roadAddress,
          entZip: data.zonecode,
        }));
      },
    }).open();
  };

  const handleValidateAndCheck = async () => {
    const isValid = await fnValidateEmail(formData.picEml);
    if (isValid) {
      emlDplChk();
    }
  };

  const emlDplChk = () => {
    const url = '/member/duplicateUserEmlChk.do';
    const param = {
      userEml: formData.picEml,
      pageType: 'info',
    };
    nlPost(url, param)
      .then(response => {
        if (response instanceof Error) {
          this.modalService.errorAlert(
            '데이터 처리중 에러가 발생하였습니다',
            () => {}
          );
        } else if (formData.picEml == formData.picOrgnlEml) {
          setDplChkBool(true);
          setUserEmlChg(false);
          modalService.successAlert('사용 가능한 이메일 주소입니다.', () => {
            return;
          });
        } else {
          if (response == true) {
            setDplChkBool(true);
            setUserEmlChg(false);
            modalService.successAlert('사용 가능한 이메일 주소입니다.');
          } else if (response == false) {
            setDplChkBool(false);
            setUserEmlChg(true);
            modalService.errorAlert('사용 불가능한 이메일 주소입니다.');
            setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
          }
        }
      })
      .catch(error => {});
  };

  const fnValidateEmail = async email => {
    if (!isValidEmail(email)) {
      modalService.errorAlert('이메일 형식이 아닙니다.');
      setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
      return false;
    } else {
      return true;
    }
  };

  const handleInputChangeName = e => {
    const { id, value } = e.target;
    // 숫자가 포함되지 않은 경우에만 상태를 업데이트
    if (!/\d/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    }
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">기업사용자관리</h2>
      </div>
      {/* //페이지 타이틀 영역 */}
      {/* table list */}
      <div className="tbl-wrap">
        <h3 className="block-tit">기업정보</h3>
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">
                아이디 <em className="star-require">*</em>
              </th>
              <td>
                <label className="hidden-label" htmlFor="entId">
                  라벨
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    id="entId"
                    value={formData.entId || ''}
                    className="form-control md"
                    placeholder="아이디 입력"
                    disabled
                    aria-labelledby="entId"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                기업명 <em className="star-require">*</em>
              </th>
              <td>
                <label className="hidden-label" htmlFor="entNm">
                  라벨
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    id="entNm"
                    value={formData.entNm || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    className="form-control md"
                    placeholder="기업명 입력"
                    aria-labelledby="entNm"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                대표자 <em className="star-require">*</em>
              </th>
              <td>
                <label className="hidden-label" htmlFor="entRprsv">
                  라벨
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control md"
                    placeholder="대표자 입력"
                    id="entRprsv"
                    value={formData.entRprsv || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    aria-labelledby="entRprsv"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                주소 <em className="star-require">*</em>
              </th>
              <td>
                <label className="hidden-label" htmlFor="entAddr">
                  라벨
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control md"
                    id="entAddr"
                    value={formData.entAddr || ''}
                    onChange={handleInputChange}
                    maxLength={200}
                    aria-labelledby="entAddr"
                    readOnly
                  />
                  <button
                    type="button"
                    className="btn md secondary"
                    onClick={handleAddressSearch}
                  >
                    주소 찾기
                  </button>
                  <label className="hidden-label" htmlFor="entDaddr">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control md"
                    id="entDaddr"
                    value={formData.entDaddr || ''}
                    onChange={handleInputChange}
                    maxLength={200}
                    aria-labelledby="entDaddr"
                  />
                  <label className="hidden-label" htmlFor="entZip">
                    라벨
                  </label>
                  <input
                    type="text"
                    id="entZip"
                    className="form-control md"
                    value={formData.entZip || ''}
                    onChange={handleInputChange}
                    readOnly
                    maxLength={5}
                    aria-labelledby="entZip"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                전화번호 <em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="entTelno">
                    라벨
                  </label>
                  <NumericFormat
                    type="text"
                    id="entTelno"
                    className="form-control"
                    value={formData.entTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">팩스번호</th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="entFxno">
                    라벨
                  </label>
                  <NumericFormat
                    type="text"
                    id="entFxno"
                    className="form-control"
                    value={formData.entFxno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* //table list */}
      {/* table list */}
      <div className="tbl-wrap">
        <h3 className="block-tit">담당자 정보</h3>
        <table className="tbl data row">
          <tbody>
            <tr>
              <th scope="row">
                담당자명<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="picNm">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control md"
                    id="picNm"
                    value={formData.picNm || ''}
                    onChange={handleInputChangeName}
                    maxLength={20}
                    aria-labelledby="picNm"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                담당부서<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="picDept">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control md"
                    id="picDept"
                    value={formData.picDept || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    aria-labelledby="picDept"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                이메일 주소<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="picEml">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control md"
                    id="picEml"
                    value={formData.picEml || ''}
                    onChange={handleInputChange}
                    maxLength={50}
                    aria-labelledby="picEml"
                  />
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={() => {
                      handleValidateAndCheck();
                    }}
                  >
                    중복검사
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                전화번호<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="picTelno">
                    라벨
                  </label>
                  <NumericFormat
                    type="text"
                    id="picTelno"
                    className="form-control"
                    value={formData.picTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                  />
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                휴대전화<em className="star-require">*</em>
              </th>
              <td>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="picMblTelno">
                    라벨
                  </label>
                  <NumericFormat
                    type="text"
                    id="picMblTelno"
                    className="form-control"
                    value={formData.picMblTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    allowNegative={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* //table list */}

      <div className="page-btn-wrap both">
        <button
          type="button"
          className="btn xlg primary"
          onClick={() => {
            beforeUpdate();
          }}
        >
          저장
        </button>
      </div>
    </>
  );
};

export default AdminInfo;
